<section class="notification">
  <div class="notification_head" :class="state.deviceListData<=0?'nodata':''">
    <Tab class="tab" @onClick="onClickTab" :tabText="state.tab_data"></Tab>
    <div class="table_back">
      <div class="control">
        <div>
          <Select class="select_device" :options="state.tab=='join'? state.askOP : state.device_op"
            v-model:selected="state.device" :isDisable="state.device_op.length==1" @onChange="selectDevice"></Select>
          <Select class="select_device" v-if="state.tab == 'unlock'" :options="state.function_op"
            v-model:selected="state.function_name" :isDisable="state.device_op.length==1" @onChange="selectFunction"></Select>
        </div>


        <div v-if="state.tab == 'join'||state.tab == 'unlock'" class="btn">
          <Button v-if="state.send.length==0" type="full" :disable="true" class="button" colors="dark1" theme="2"
            wd="sm" h="mlg" :text="t('__d7d_n17r.__approval')"></Button>
          <Button v-else type="full" :disable="false" class="button" colors="dark1" theme="2" wd="sm" h="mlg"
            :text="t('__d7d_n17r.__approval')" @onClick="approve_click"></Button>
          <Button v-if="state.send.length==0" type="full" :disable="true" class="button ml16" colors="dark1" theme="2"
            wd="sm" h="mlg" :text="t('__d7d_n17r.__reject')"></Button>
          <Button v-else type="full" :disable="false" class="button ml16" colors="dark1" theme="2" wd="sm" h="mlg"
            :text="t('__d7d_n17r.__reject')" @onClick="approve_click('reject')"></Button>
        </div>
        <div v-if="state.tab == 'unbind'||state.tab == 'other'">
          <Button v-if="state.send.length==0" :disable="true" type="full" class="btn_delete" colors="dark1" theme="2"
            wd="sm" h="mlg" icon="asus_proart_sw_ico_delete" :text="t('__common.__delete')"></Button>
          <Button v-else :disable="false" type="full" class="btn_delete" colors="dark1" theme="2" wd="sm" h="mlg"
            icon="asus_proart_sw_ico_delete" :text="t('__common.__delete')" @onClick="delete_click"></Button>
        </div>
      </div>
      <div class="table">
        <Table @tableSort="tableSort" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
          @goTableLink="goTableLink" :columns="colComputed" :data="state.deviceListData" tablePadding="20"
          :checkBox="true" :defaultCheck="state.defaultCheckIndexList">
          <template #empty="{text}">
            <div class="Nodata">{{$t('__d7d_n17r.__noAnyMessage')}}</div>
          </template>
        </Table>
      </div>
      <!-- <div class="Nodata">No any message</div> -->
    </div>
  </div>
  <div class="tabFooter">
    <Pagination :totalPage="state.meta.total_page" :input="true" position="start" :nowPage="state.meta.current"
      :range="5" @changePage="changePage"></Pagination>
  </div>
</section>